import React, { useState } from 'react';

const ClientHeader = ({
  inputSearch,
  count,
  onSearchSubmit,
  onSearchTextChange,
  handleAdd,
  onClearSearch,
  statusFilter,
  onStatusFilter,
  branchFilter,
  onBranchFilter,
  customerFilter,
  onCustomerFilter,
  branches = [],
  customers = [],
  client,
  showForm,
}) => {

  if (showForm) {
    return (
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
        <h1 className="text-xl font-bold uppercase text-[#293686]">
          {client ? `Edit Client(${client.client_code})` : 'Add Client'}
        </h1>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3 mb-4">
      {/* Row 1: title + search + add */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3">
        <h1 className="text-xl font-bold uppercase text-[#293686]">Clients ({count})</h1>
        <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto">
          <form onSubmit={onSearchSubmit} className="relative w-full md:w-72">
            <input
              type="text"
              placeholder="Search by code, phone, email, etc."
              value={inputSearch}
              onChange={onSearchTextChange}
              className="border rounded w-full pl-3 pr-10 py-1.5 text-sm"
            />
            {inputSearch && (
              <button
                type="button"
                onClick={onClearSearch}
                className="absolute right-8 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                title="Clear"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
            <button
              type="submit"
              className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
              title="Search"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z" />
              </svg>
            </button>
          </form>
          <button
            onClick={handleAdd}
            className="px-4 text-sm bg-[#E91C24] text-white py-2 rounded-md hover:bg-[#c3151d] transition"
          >
            + Add Client
          </button>
        </div>
      </div>

      {/* Row 2: filters */}
      <div className="flex flex-wrap gap-2 items-center">
        {/* Status */}
        <select
          className="border px-3 py-1.5 text-sm rounded uppercase"
          value={statusFilter}
          onChange={onStatusFilter}
        >
          <option value="All">All Status</option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>

        {/* Branch */}
        <select
          className="border px-3 py-1.5 text-sm rounded"
          value={branchFilter}
          onChange={onBranchFilter}
        >
          <option value="">All Branches</option>
          {branches.map(b => (
            <option key={b.id} value={b.id}>{b.name}</option>
          ))}
        </select>

        {/* Customer */}
        <select
          className="border px-3 py-1.5 text-sm rounded"
          value={customerFilter}
          onChange={onCustomerFilter}
        >
          <option value="">All Customers</option>
          {customers.map(c => (
            <option key={c.id} value={c.id}>{c.name || c.user?.name}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ClientHeader;
